import { graphql } from "gatsby"
import React from "react"
import ApplicationForm from "../components/ApplicationForm"
import Banner from "../components/Banner"
import BlogListingWithFilter from "../components/BlogListingWithFilter"
import BookTable from "../components/BookTable"
import CareerListing from "../components/CareerListing"
import CollectionListing from "../components/CollectionListing"
import FullwidthImageContent from "../components/FullwidthImageContent"
import GetInTouchBox from "../components/GetInTouchBox"
import ImageCardGrid from "../components/ImageCardGrid"
import ImageSliderWithContent from "../components/ImageSliderWithContent"
import ImageWithContent from "../components/ImageWithContent"
import Introduction from "../components/Introduction"
import KoveCard from "../components/KoveCard"
import KoveTimeline from "../components/KoveTimeline"
import LatestNews from "../components/LatestNews"
import LegalInformation from "../components/LegalInformation"
import MiscrositeSlider from "../components/MiscrositeSlider"
import PlanYourEventListing from "../components/PlanYourEventListing"
import PressListing from "../components/PressListing"
import PromotionsListing from "../components/PromotionsListing"
import RelatedCards from "../components/RelatedCards"
import SearchListing from "../components/SearchListing"
import SimpleContent from "../components/SimpleContent"
import Testimonial from "../components/Testimonial"

const Main = props => {
  const modules = props.modules.pageContent
  const { location } = props

  const components = {
    Banner: Banner,
    Introduction: Introduction,
    MiscrositeSlider: MiscrositeSlider,
    ImageCardGrid: ImageCardGrid,
    KoveCard: KoveCard,
    FullwidthImageContent: FullwidthImageContent,
    Testimonial: Testimonial,
    LatestNews: LatestNews,
    SimpleContent: SimpleContent,
    CollectionListing: CollectionListing,
    ImageSliderWithContent: ImageSliderWithContent,
    RelatedCards: RelatedCards,
    PromotionsListing: PromotionsListing,
    PlanYourEventListing: PlanYourEventListing,
    ImageWithContent: ImageWithContent,
    KoveTimeline: KoveTimeline,
    BlogListingWithFilter: BlogListingWithFilter,
    GetInTouchBox: GetInTouchBox,
    LegalInformation: LegalInformation,
    PressListing: PressListing,
    ApplicationForm: ApplicationForm,
    BookTable: BookTable,
    CareerListing: CareerListing,
    SearchListing: SearchListing,
  }

  return (
    <>
      {modules
        ? modules.map((module, i) => {
            const moduleName = module.__typename.replace(
              "WpPage_Pagecontent_PageContent_",
              ""
            )
            return (
              components[moduleName] &&
              React.createElement(components[moduleName], {
                key: i,
                module,
                location,
                i,
              })
            )
          })
        : null}
    </>
  )
}

export default Main

export const MainFragment = graphql`
  fragment MainFragment on WpPage {
    pageContent {
      pageContent {
        __typename
        ...PageBannerFragment
        ...PageIntroductionFragment
        ...PageMiscrositeSliderFragment
        ...PageImageCardGridFragment
        ...PageKoveCardFragment
        ...PageFullwidthImageContentFragment
        ...PageTestimonialFragment
        ...PageLatestNewsFragment
        ...PageSimpleContentFragment
        ...PageCollectionListingFragment
        ...PageImageSliderWithContentFragment
        ...PageRelatedCardsFragment
        ...PagePromotionsListingFragment
        ...PagePlanYourEventListingFragment
        ...PageImageWithContentFragment
        ...PageKoveTimelineFragment
        ...PageBlogListingWithFilterFragment
        ...PageGetInTouchBoxFragment
        ...PageLegalInformationFragment
        ...PagePressListingFragment
        ...PageApplicationFormFragment
        ...PageBookTableFragment
        ...PageCareerListingFragment
      }
    }
  }
`
